import { EntitiesEnum } from 'src/generated/EntitiesEnum';

export { EntitiesEnum };
